import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { getList, addData, editData } from '../../helpers/fackBackend_Helper';

function* getPortinNetworkResponse() {
    try {
        const response = yield call(getList, '/portinNetwork');
        if (response.response.Status) {
            yield put(actions.getNetworkByDealerPortinMappingSuccess(response.response.Data));
        } else {
            yield put(actions.getNetworkByDealerPortinMappingFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getNetworkByDealerPortinMappingFailed(error));
    }
}

function* createPortinActivationResponse({ data }) {
    try {
        const response = yield call(addData, '/createPortinActivation', data);
        if (response.response.Status) {
            const responseList = yield call(addData, '/getBulkPortinActivationList');
            if (responseList.response.Status) {
                yield put(actions.createPortinActivationSuccess(responseList.response.Data, response.response.Message));
            }
        } else {
            yield put(actions.createPortinActivationFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.createPortinActivationFailed(error));
    }
}

function* getBulkPortinActivationResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getBulkPortinActivation', data);
        if (response.response.Status) {
            yield put(actions.getBulkPortinActivationSuccess(response.response.Data));
        } else {
            yield put(actions.getBulkPortinActivationFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getBulkPortinActivationFailed(error));
    }
}

function* checkSerialNumberResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/checkSerialNumberByBatchID', data);
        if (response.response.Status) {
            yield put(actions.checkSerialNumberByBatchSuccess(response.response.Data));
        } else {
            yield put(actions.checkSerialNumberByBatchFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.checkSerialNumberByBatchFailed(error));
    }
}

function* updateManualPortinActivationResponse({ data }) {
    try {
        const response = yield call(editData, '/updateISPWholeSaleNetActReqWhileAutomation', data);
        if (response.response.Status) {
            yield put(actions.updateManualPortinActivationSuccess(response.response.Message));
            yield put(actions.getBulkPortinActivationList())
        } else {
            yield put(actions.updateManualPortinActivationFailed(response.response.Message));
            yield put(actions.getBulkPortinActivationList())
        }
    } catch (error) {
        yield put(actions.updateManualPortinActivationFailed(error));
    }
}

function* updatePortinStatusResponse({ payload: { updateData, data } }) {
    try {
        const response = yield call(addData, '/updatePortinStatus', updateData);
        if (response.response.Status) {
            yield put(actions.updatePortinStatusSuccess(response.response.Message));
            yield put(actions.getBulkPortinActivationListByBatchID(data))
        } else {
            yield put(actions.updatePortinStatusFailed(response.response.Message));
            yield put(actions.getBulkPortinActivationListByBatchID(data))
        }
    } catch (error) {
        yield put(actions.updatePortinStatusFailed(error));
    }
}

function* updatePortinActivationBulkStatusResponse({ payload: { searchData } }) {
    try {
        const response = yield call(addData, '/updateAllProcessingRequests', searchData);
        if (response.response.Status) {
            yield put(actions.updatePortinActivationBulkStatusSuccess(response.response.Message));
            yield put(actions.getBulkPortinActivation(searchData))
        } else {
            yield put(actions.updatePortinActivationBulkStatusFailed(response.response.Message));
            yield put(actions.getBulkPortinActivation(searchData))
        }
    } catch (error) {
        yield put(actions.updatePortinActivationBulkStatusFailed(error));
    }
}

function* getBulkPortinActivationRequestResponse() {
    try {
        const response = yield call(addData, '/getBulkPortinActivationList');
        if (response.response.Status) {
            yield put(actions.getBulkPortinActivationListSuccess(response.response.Data));
        } else {
            yield put(actions.getBulkPortinActivationListFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getBulkPortinActivationListFailed(error));
    }
}

function* getBulkPortinActivationByBatchIDResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getPortinActivationListByBatchID', data);
        if (response.response.Status) {
            yield put(actions.getBulkPortinActivationListByBatchIDSuccess(response.response.Data));
        } else {
            yield put(actions.getBulkPortinActivationListByBatchIDFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getBulkPortinActivationListByBatchIDFailed(error));
    }
}

function* getPortinActivationsResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/getPortingActivationList?page=${data.page}&perPage=${data.perPage}&search=${data.search}&sortColumn=${data.sortColumn}&sortDirection=${data.sortDirection}`);
        if (response.response.Status) {
            yield put(actions.getPortinActivationsSuccess(response.response));
        } else {
            yield put(actions.getPortinActivationsFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getPortinActivationsFailed(error.message));
    }
}


export default function* rootSaga() {
    yield all([takeEvery(actions.GET_PORTIN_ACTIVATIONS, getPortinActivationsResponse)]);
    yield all([takeEvery(actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING, getPortinNetworkResponse)]);
    yield all([takeEvery(actions.CREATE_PORTIN_ACTIVATION, createPortinActivationResponse)]);
    yield all([takeEvery(actions.GET_BULK_PORTIN_ACTIVATION, getBulkPortinActivationResponse)]);
    yield all([takeEvery(actions.CHECK_SERIAL_NUMBER_BY_BATCH, checkSerialNumberResponse)]);
    yield all([takeEvery(actions.UPDATE_MANUAL_PORTIN_ACTIVATION, updateManualPortinActivationResponse)]);
    yield all([takeEvery(actions.UPDATE_PORTIN_STATUS, updatePortinStatusResponse)]);
    yield all([takeEvery(actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS, updatePortinActivationBulkStatusResponse)]);
    yield all([takeEvery(actions.GET_BULK_PORTIN_ACTIVATION_LIST, getBulkPortinActivationRequestResponse)]);
    yield all([takeEvery(actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID, getBulkPortinActivationByBatchIDResponse)]);
}